export default __webpack_public_path__ + "static/media/autofarm.0e89abbe.svg";